import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { CSSTransition } from 'react-transition-group';
import { Button, Typography } from '@mui/material';

import { PAYMENT_FAILURE_STATUS, PAYMENT_SUCCESS_STATUS, useReady } from '../shared';

import { Container, Paper, Icon } from './common';

import {
  StyledNotificationTitle,
  StyledPaymentStatusContainer,
  StyledPStatusIconContainer,
} from './styled/PaymentStatus.styled';

export default function PaymentStatus() {
  const history = useHistory();
  const ready = useReady();
  const { status } = useParams();

  return (
    <CSSTransition in={ready} timeout={600} classNames="slow-fade" unmountOnExit>
      <Container>
        <Paper>
          <StyledPaymentStatusContainer>
            {status === PAYMENT_SUCCESS_STATUS && (
              <>
                <StyledPStatusIconContainer>
                  <Icon icon="notification.success" alt="success" />
                </StyledPStatusIconContainer>

                <StyledNotificationTitle>
                  <Typography variant="h3">
                    <FormattedMessage id="customer.details.digital.payment.success.title" />
                  </Typography>
                </StyledNotificationTitle>
              </>
            )}

            {status === PAYMENT_FAILURE_STATUS && (
              <>
                <StyledPStatusIconContainer>
                  <Icon icon="notification.warning" alt="success" />
                </StyledPStatusIconContainer>

                <StyledNotificationTitle>
                  <Typography variant="h3">
                    <FormattedMessage id="customer.details.digital.payment.failure.title" />
                  </Typography>
                </StyledNotificationTitle>

                <StyledNotificationTitle>
                  <Typography variant="p">
                    <FormattedMessage id="customer.details.digital.payment.failure.desc" />
                  </Typography>
                </StyledNotificationTitle>
              </>
            )}

            <Button variant="outlined" onClick={() => history.push(`/user-info`)}>
              <Typography variant="buttons">
                <FormattedMessage id="customer.details.digital.payment.success.btn" />
              </Typography>
            </Button>
          </StyledPaymentStatusContainer>
        </Paper>
      </Container>
    </CSSTransition>
  );
}
